__turbopack_context__.v({
  "blockquote": "cp7rsq_blockquote",
  "highlight": "cp7rsq_highlight",
  "placeholder": "cp7rsq_placeholder",
  "table": "cp7rsq_table",
});
